
import { AppComponent } from './app.component';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
// import { AddyourcardComponent } from './addyourcard/addyourcard.component';
// import { AdvancesearchComponent } from './advancesearch/advancesearch.component';
// import { AllCategoryComponent } from './all-category/all-category.component';
// import { B2bRegistrationComponent } from './b2b-registration/b2b-registration.component';
// import { B2cRegistrationComponent } from './b2c-registration/b2c-registration.component';
// import { CartPreviewComponent } from './cart-preview/cart-preview.component';
// import { CategoryComponent } from './category/category.component';
// import { ChangepwdComponent } from './changepwd/changepwd.component';
// import { CheckoutComponent } from './checkout/checkout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
// import { ContactComponent } from './contact/contact.component';
// import { DashboardComponent } from './dashboard/dashboard.component';

// import { LoginComponent } from './login/login.component';
// import { MajProdComponent } from './maj-prod/maj-prod.component';
// import { NewCustomersComponent } from './new-customers/new-customers.component';
// import { NotFoundComponent } from './not-found/not-found.component';
// import { OrderManagementComponent } from './order-management/order-management.component';
// import { BackOrdersComponent } from './order-management/back-orders/back-orders.component';
// import { CustomerProductsComponent } from './order-management/customer-products/customer-products.component';
// import { HelpDeskComponent } from './order-management/help-desk/help-desk.component';
// import { InvoicePaymentComponent } from './order-management/invoice-payment/invoice-payment.component';
// import { InvoicesComponent } from './order-management/invoices/invoices.component';
// import { OrderHistoryComponent } from './order-management/order-history/order-history.component';
// import { OrderViewComponent } from './order-management/order-view/order-view.component';
// import { PendingOrderComponent } from './order-management/pending-order/pending-order.component';
// import { PurchaseHistoryComponent } from './order-management/purchase-history/purchase-history.component';
// import { PendingOrderReviewComponent } from './pending-order-review/pending-order-review.component';
// import { ProductComponent } from './product/product.component';
// import { ProductDetailComponent } from './product-detail/product-detail.component';
// import { ReviewOrderComponent } from './review-order/review-order.component';
// import { RfqlistComponent } from './rfqlist/rfqlist.component';
// import { SalesLoginComponent } from './sales-login/sales-login.component';
// import { SearchBarComponent } from './search-bar/search-bar.component';
// import { ShippingAddressComponent } from './shipping-address/shipping-address.component';
// import { SortFiltersComponent } from './sort-filters/sort-filters.component';
// import { UserComponent } from './user/user.component';
// import { userprofileComponent } from './userprofile/userprofile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DemoService } from './services/demo.service';
import { DataService } from './services/data.service';
import { SEOService } from './services/seo.service';
import { CartService } from './services/cart.service';
import { MenuService } from './services/menu.service';
import { ContactService } from './services/contact.service';
import { RegistrationService } from './services/registration.service';
import { OrderManagementService } from './services/order-management.service';
import { CheckoutService } from './services/checkout.service';
import { RoutingState } from './services/routingState';
import { AuthGuardGuard } from './auth-guard.guard';
import { DecimalPipe } from '@angular/common';
import { LoadingService } from './services/loading.service';
import { UrlSerializer } from '@angular/router';
import { LowerCaseUrlSerializer } from './services/LowercaseUrlSerializer';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/interceptor';

import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
// import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { OrderModule } from 'ngx-order-pipe';
// import { MatSelectModule } from '@angular/material/select';
// import { MatCheckboxModule } from '@angular/material/checkbox';
// import { MatDialogModule } from '@angular/material/dialog';
// import { MatTabsModule } from '@angular/material/tabs';
// import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
// import { RecaptchaModule } from 'ng-recaptcha';
// import { NgxGalleryModule } from '@kolkov/ngx-gallery';

// import { NgxPrintModule } from 'ngx-print';
// import { DpDatePickerModule } from 'ng2-date-picker';
import { MY_DATE_FORMATS } from './model/common.model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
// TransferHttpCacheModule removed — was from @nguniversal/common (CVE-2026-27739)
// Angular 15 ServerTransferStateModule in app.server.module.ts handles state transfer
// import { SouthernQuotesComponent } from './southern-quotes/southern-quotes.component';
// import { NgxSliderModule } from '@angular-slider/ngx-slider';
// import { AutocompleteLibModule } from 'angular-ng-autocomplete';
// import { sitemapComponent } from './sitemap/sitemap.component';
// import { QuickOrderPadComponent } from './quick-order-pad/quick-order-pad.component';
// import { infopageComponent } from './infopage/infopage.component';
// import { rmaComponent } from './rma/rma.component';
// import { SelectDropDownModule } from 'ngx-select-dropdown';
// import { OpenShipmentComponent } from './order-management/open-shipment/open-shipment.component';
import { AppRoutingModule } from './app-routing.module';
// import { NgxPaginationModule } from 'ngx-pagination';
import { sharedModule } from './shared.module';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

@NgModule({
  declarations: [
    AppComponent,
    // AddyourcardComponent,
    // AdvancesearchComponent,
    // AllCategoryComponent,
    // B2bRegistrationComponent,
    // B2cRegistrationComponent,
    // CartPreviewComponent,
    // CategoryComponent,
    // ChangepwdComponent,
    // CheckoutComponent,
    FooterComponent,
    HeaderComponent,
    SideMenuComponent,
    // QuickOrderPadComponent,
    // ContactComponent,
    // DashboardComponent,
    // FiltersComponent,
    // LoginComponent,
    // MajProdComponent,
    // NewCustomersComponent,
    // NotFoundComponent,
    // OrderManagementComponent,
    // BackOrdersComponent,
    // CustomerProductsComponent,
    // HelpDeskComponent,
    // InvoicePaymentComponent,
    // InvoicesComponent,
    // OrderHistoryComponent,
    // OrderViewComponent,
    // PendingOrderComponent,
    // PurchaseHistoryComponent,
    // PendingOrderReviewComponent,
    // ProductComponent,
    // ProductDetailComponent,
    // ReviewOrderComponent,
    // RfqlistComponent,
    // SalesLoginComponent,
    // SearchBarComponent,
    // ShippingAddressComponent,
    // SortFiltersComponent,
    // UserComponent,
    // userprofileComponent,
    // SafePipe,
    // KeysPipe,
    // PhonePipe,
    // MillionPipe,
    // FloorPipe,
    // SplitPipe,
    // DateFormatPipe,
    // SouthernQuotesComponent,
    // sitemapComponent,
    // urlsPipe,
    // LowerPipe,
    // infopageComponent,
    // rmaComponent,
    // OpenShipmentComponent
  ],
  imports: [
    AppRoutingModule,
    // RouterModule.forRoot(AppRoutes),
    CommonModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    ReactiveFormsModule,
    // NgxPaginationModule,
    // BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot({}),
    NgxLoadingModule.forRoot({}),
    TypeaheadModule.forRoot(),
    // NgMultiSelectDropDownModule.forRoot(),
    // OrderModule,
    // MatSelectModule,
    // MatCheckboxModule,
    // MatDialogModule,
    // MatTabsModule,
    // RecaptchaModule,
    // NgxGalleryModule,
    // NgxPrintModule,
    // DpDatePickerModule,
    // NgxSliderModule,
    // AutocompleteLibModule,
    // SelectDropDownModule,
    sharedModule,
  ],
  providers: [
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    DemoService,
    DataService,
    SEOService,
    CartService,
    MenuService,
    ContactService,
    RegistrationService,
    OrderManagementService,
    CheckoutService,
    RoutingState,
    AuthGuardGuard,
    DecimalPipe,
    LoadingService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
